var React = require('react');

function CapitalIdeas (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#FFF","strokeWidth":"2","fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M5.615 1H15v9.385H5.615z","key":0}),React.createElement("path",{"d":"M1 5.615h9.385V15H1z","key":1})]));
}

CapitalIdeas.displayName = "CapitalIdeas";

CapitalIdeas.defaultProps = {"width":"16","height":"16"};

module.exports = CapitalIdeas;

CapitalIdeas.default = CapitalIdeas;
